import { useIntl } from "react-intl"

import { isIntlField, mapToFieldCalculated } from "./SimpleTable.utils"
import { Column, Field, Header, RawField } from "./SimpleTable.domain"

const EMPTY_VALUE = { value: "" }

const useProcessorField = () => {
	const intl = useIntl()

	const mapToTranslateField = (field: Field): RawField => {
		if (typeof field === "string") return { value: field }

		if (!isIntlField(field)) return field

		const { intl: intlFields } = field
		const { values, ...descriptor } = intlFields
		const translatedValue = intl.formatMessage(descriptor, values)

		return {
			value: translatedValue,
			...field,
		}
	}

	const processHeaders = (headers: Header[]) =>
		headers.map((header) => {
			const translateField = mapToTranslateField(header)
			return mapToFieldCalculated("header", translateField)
		})

	const processColumns = <H extends Header[]>(
		data: Column<H>[],
		headers: H
	) => {
		const headersIds = headers.map(
			({ id }) => id as keyof Column<typeof headers>
		)

		return data.map((column) =>
			headersIds.map((id) => {
				const field = column[id] ?? EMPTY_VALUE
				const translateField = mapToTranslateField(field)
				return mapToFieldCalculated("column", translateField)
			})
		)
	}

	return { mapToTranslateField, processHeaders, processColumns }
}

export default useProcessorField
